/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type LazyImageWrapper_item$ref = any;
export type PdpRespSimilarItemCarousel_item$ref = any;
export type PdpRespSimilarItemCarousel_item = {
    readonly title: string | null;
    readonly pdpURL: string | null;
    readonly isArt: boolean | null;
    readonly creators: ReadonlyArray<{
        readonly creator: {
            readonly name: string | null;
        } | null;
    } | null> | null;
    readonly photos: ReadonlyArray<{
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": LazyImageWrapper_item$ref;
    readonly " $refType": PdpRespSimilarItemCarousel_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSimilarItemCarousel_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pdpURL",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isArt",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "creators",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemCreator",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creator",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Creator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "photos",
            "storageKey": "photos(limit:1)",
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 1
                }
            ],
            "concreteType": "ItemPhoto",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "versions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPhotoVersion",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "webPath",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "LazyImageWrapper_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'e80e7fb3372010f5b0cb0614eb1fe1cd';
export default node;
